import { ShopperPurchaseResponse } from '@hotmart/hub-api-client/types'
import { atom } from 'recoil'

const PurchaseStore = atom<ShopperPurchaseResponse>({
  key: 'PurchaseStore',
  default: null
})

export default PurchaseStore
